import { Component, Renderer2, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { Title, Meta } from '@angular/platform-browser';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { LocalCacheService } from '../../services/localCache.service';
@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent, RouterLink],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
})
export class ErrorPageComponent {
  public errorMessage: string | any;
  public returnPage: string | any;
  public isPolicyStatus: boolean = false;
  constructor(
    private router: Router,
    private titleService: Title,
    private route: ActivatedRoute,
    private localCacheService: LocalCacheService,
    private renderer: Renderer2,
    private metaService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.titleService.setTitle('Not found > World2Cover Travel Insurance');
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Not found > World2Cover Travel Insurance',
    });
  }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.errorMessage = '';
    this.isPolicyStatus =
      this.route.snapshot.paramMap.get('status') === 'i' ? true : false;
    this.localCacheService.clearAllSession();
    const canonicalUrl = 'https://www.world2cover.com.au/';
    const link: HTMLLinkElement = this.renderer.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalUrl);
    this.renderer.appendChild(document.head, link);
  }

  goToStepOne(): void {
    this.router.navigate(['']);
  }
}
